// generated from samples

import { z } from "zod/v4";

export const performedOrderPlacedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedOrderPlaced"),
  is_any_order: z.boolean(),
  product_key: z.string().optional(),
  product_value: z.string().optional(),
});
